import { z as zod } from "zod";
import { MediaRef } from "@/app/features/shared/__to_be_integrated/types/general/media/media";

export const MEDIA_REF_SCHEMA_TAG = "media-ref";

export const MediaRefSchema = zod.custom<MediaRef>(
    (v): v is MediaRef => !!v && typeof v === 'object',
    { message: 'Kein gültiges Bild' }
).describe(MEDIA_REF_SCHEMA_TAG);
